import { render, staticRenderFns } from "./patientSelect.vue?vue&type=template&id=284a72bd&scoped=true"
import script from "./patientSelect.vue?vue&type=script&lang=js"
export * from "./patientSelect.vue?vue&type=script&lang=js"
import style0 from "./patientSelect.vue?vue&type=style&index=0&id=284a72bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a72bd",
  null
  
)

export default component.exports